import {GET_ROWS_ERROR} from "../../reducers/rowsReducer";


export const getRowsError = (error) =>{
    return {
        type: GET_ROWS_ERROR,
        payload: {error}
    }
}